module.exports = __webpack_public_path__ + "static/media/article-11-option-4-1017776.d4dad2f6.png";